import React, { useState } from "react";
import styled from "styled-components";
import { LuUpload, LuAsterisk, LuUser, LuUsers } from "react-icons/lu";
import { FaPlus } from "react-icons/fa6";
import { IoMdClose } from "react-icons/io";
import { IoShieldOutline } from "react-icons/io5";
import { FiAward } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5";
import { TfiStatsUp } from "react-icons/tfi";
import { MdOutlineFileUpload } from "react-icons/md";
import { v4 as uuidv4 } from "uuid";

const CreatorProfileForm = () => {
  const [formData, setFormData] = useState({
    profilePicture: null,
    fullName: "Dr. Jordan Peterson",
    professionalTitle: "Clinical Psychologist",
    yearsOfExperience: "10+ years experience",
    shortDescription: "Helping students manage anxiety and stress",
    detailedBio: "",
    languages: ["English", "Hindi", "French"],
    specializations: ["Anxiety", "Depression", "Stress Management", "Fun"],
    education: [
      "Ph.D. in Clinical Psychology, Delhi University",
      "M.Phil. in Clinical Psychology",
      "Licensed Clinical Psychologist (RCI)",
    ],
    expertise: [
      "Cognitive Behavioral Therapy",
      "Mindfulness-Based Therapy",
      "Solution-Focused Therapy",
    ],
    tags: [
      "#student counseling",
      "#exam stress",
      "#mental health",
      "#anxiety relief",
      "#depression support",
    ],
    licenses: [
      {
        id: 1,
        name: "Clinical Psychology License",
        number: "RCI/PSY/12345",
        issueDate: "Jan 2013",
        expiryDate: "Jan 2028",
      },
      {
        id: 2,
        name: "Certified CBT Practitioner",
        number: "CBT/IND/6789",
        issueDate: "Mar 2015",
        expiryDate: "Lifetime",
      },
    ],
    awards: [
      {
        id: 1,
        title: "Excellence in Mental Health Care",
        organization: "Indian Psychological Association",
        year: "2022",
        description: "Brief description of the award and why you received it",
      },
    ],
    achievements: [
      {
        id: 1,
        title: "Published Research on Student Anxiety",
        year: "2021",
        description: "Detailed description of your achievement",
      },
      {
        id: 2,
        title: "TED Talk on Mental Health",
        year: "2019",
        description: "Detailed description of your achievement",
      },
    ],
    memberships: [
      {
        id: 1,
        organization: "American Psychological Association",
        role: "Senior Member",
        since: "2013",
      },
      {
        id: 2,
        organization: "Rehabilitation Council of USA",
        role: "Registered Psychologist",
        since: "2013",
      },
    ],
    documents: [
      { id: 1, name: "RCI_License.pdf", type: "PDF Document" },
      { id: 2, name: "PhD_Certificate.pdf", type: "PDF Document" },
    ],
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddItem = (section, value) => {
    if (!value.trim()) return;

    setFormData((prev) => {
      const currentItems = [...prev[section]];
      currentItems.push(value.trim());
      return { ...prev, [section]: currentItems };
    });
  };

  const handleRemoveItem = (section, index) => {
    setFormData((prev) => {
      const currentItems = [...prev[section]];
      currentItems.splice(index, 1);
      return { ...prev, [section]: currentItems };
    });
  };

  const handleAddLicense = () => {
    setFormData((prev) => ({
      ...prev,
      licenses: [
        ...prev.licenses,
        {
          id: uuidv4(),
          name: "",
          number: "",
          issueDate: "",
          expiryDate: "",
        },
      ],
    }));
  };

  const handleAddAward = () => {
    setFormData((prev) => ({
      ...prev,
      awards: [
        ...prev.awards,
        {
          id: uuidv4(),
          title: "",
          organization: "",
          year: "",
          description: "",
        },
      ],
    }));
  };

  const handleAddAchievement = () => {
    setFormData((prev) => ({
      ...prev,
      achievements: [
        ...prev.achievements,
        {
          id: uuidv4(),
          title: "",
          year: "",
          description: "",
        },
      ],
    }));
  };

  const handleAddMembership = () => {
    setFormData((prev) => ({
      ...prev,
      memberships: [
        ...prev.memberships,
        {
          id: uuidv4(),
          organization: "",
          role: "",
          since: "",
        },
      ],
    }));
  };

  const handleLicenseChange = (licenseId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      licenses: prev.licenses.map((license) =>
        license.id === licenseId ? { ...license, [field]: value } : license
      ),
    }));
  };

  const handleAwardChange = (awardId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      awards: prev.awards.map((award) =>
        award.id === awardId ? { ...award, [field]: value } : award
      ),
    }));
  };

  const handleAchievementChange = (achievementId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      achievements: prev.achievements.map((achievement) =>
        achievement.id === achievementId
          ? { ...achievement, [field]: value }
          : achievement
      ),
    }));
  };

  const handleMembershipChange = (membershipId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      memberships: prev.memberships.map((membership) =>
        membership.id === membershipId
          ? { ...membership, [field]: value }
          : membership
      ),
    }));
  };

  const handleRemoveLicense = (licenseId) => {
    setFormData((prev) => ({
      ...prev,
      licenses: prev.licenses.filter((license) => license.id !== licenseId),
    }));
  };

  const handleRemoveAward = (awardId) => {
    setFormData((prev) => ({
      ...prev,
      awards: prev.awards.filter((award) => award.id !== awardId),
    }));
  };

  const handleRemoveAchievement = (achievementId) => {
    setFormData((prev) => ({
      ...prev,
      achievements: prev.achievements.filter(
        (achievement) => achievement.id !== achievementId
      ),
    }));
  };

  const handleRemoveMembership = (membershipId) => {
    setFormData((prev) => ({
      ...prev,
      memberships: prev.memberships.filter(
        (membership) => membership.id !== membershipId
      ),
    }));
  };

  const handleFileUpload = (e) => {
    // Handle file upload logic here
    console.log("File uploaded:", e.target.files[0]);
  };

  const handleRemoveDocument = (docId) => {
    setFormData((prev) => ({
      ...prev,
      documents: prev.documents.filter((doc) => doc.id !== docId),
    }));
  };

  return (
    <Container>
      {/* <Header>
        <BackButton>
          <span>←</span> Dashboard
        </BackButton>
      </Header> */}

      <FormWrapper>
        {/* Profile Picture Section */}
        <Section>
          <SectionTitle>Profile Picture</SectionTitle>
          <ProfileContainer>
            <AvatarPlaceholder />
            <UploadButtonWrapper>
              <UploadButton>
                <LuUpload />
                Upload Photo
              </UploadButton>
              <Recommendation>
                Recommended: Square image, at least 400x400px
              </Recommendation>
            </UploadButtonWrapper>
          </ProfileContainer>
        </Section>

        {/* Basic Information Section */}
        <Section>
          <SectionTitle>Basic Information</SectionTitle>
          <FormField>
            <Label>
              Full Name <LuAsterisk color="#fb2c36" />
            </Label>
            <Input
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              placeholder="Enter your full name"
            />
          </FormField>
          <FormField>
            <Label>
              Professional Title <LuAsterisk color="#fb2c36" />
            </Label>
            <Input
              name="professionalTitle"
              value={formData.professionalTitle}
              onChange={handleInputChange}
              placeholder="Enter your professional title"
            />
          </FormField>
          <FormField>
            <Label>
              Years of Experience <LuAsterisk color="#fb2c36" />
            </Label>
            <Input
              name="yearsOfExperience"
              value={formData.yearsOfExperience}
              onChange={handleInputChange}
              placeholder="Enter years of experience"
            />
          </FormField>
          <FormField>
            <Label>
              Short Description <LuAsterisk color="#fb2c36" />
            </Label>
            <Input
              name="shortDescription"
              value={formData.shortDescription}
              onChange={handleInputChange}
              placeholder="Enter a short description"
            />
            <CharacterCount>
              {formData.shortDescription.length}/120 characters
            </CharacterCount>
          </FormField>
        </Section>

        {/* About You Section */}
        <Section>
          <SectionTitle>About You</SectionTitle>
          <FormField>
            <Label>
              Detailed Bio <LuAsterisk color="#fb2c36" />
            </Label>
            <TextArea
              name="detailedBio"
              value={formData.detailedBio}
              onChange={handleInputChange}
              placeholder="Share your background, approach, and what makes you unique as a counselor..."
              rows="5"
            />
            <HelperText>
              Tell students about your background and counseling approach
            </HelperText>
          </FormField>
        </Section>

        {/* Languages Section */}
        <Section>
          <SectionTitle>Languages</SectionTitle>
          <LanguageContainer>
            <LanguageInputWrapper>
              <LanguageInput
                placeholder="Add a language (e.g., English, Hindi)"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleAddItem("languages", e.target.value);
                    e.target.value = "";
                  }
                }}
              />
              <PlusButton
                onClick={() => {
                  const input = document.querySelector(".language-input");
                  if (input && input.value.trim()) {
                    handleAddItem("languages", input.value);
                    input.value = "";
                  }
                }}
              >
                <FaPlus size={14} />
              </PlusButton>
            </LanguageInputWrapper>
            <LanguageTags>
              {formData.languages.map((lang, index) => (
                <LanguageTag key={index}>
                  {lang}{" "}
                  <RemoveIcon
                    onClick={() => handleRemoveItem("languages", index)}
                  />
                </LanguageTag>
              ))}
            </LanguageTags>
          </LanguageContainer>
        </Section>

        {/* Specializations Section */}
        <Section>
          <SectionTitle>Specializations</SectionTitle>
          <SpecializationContainer>
            <SpecializationInputWrapper>
              <SpecializationInput
                placeholder="Add a specialization (e.g., Anxiety, Depression)"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleAddItem("specializations", e.target.value);
                    e.target.value = "";
                  }
                }}
              />
              <PlusButton
                onClick={() => {
                  const input = document.querySelector(".specialization-input");
                  if (input && input.value.trim()) {
                    handleAddItem("specializations", input.value);
                    input.value = "";
                  }
                }}
              >
                <FaPlus size={14} />
              </PlusButton>
            </SpecializationInputWrapper>
            <SpecializationTags>
              {formData.specializations.map((spec, index) => (
                <SpecializationTag key={index}>
                  {spec}{" "}
                  <RemoveIcon
                    onClick={() => handleRemoveItem("specializations", index)}
                    color="#dc3545"
                  />
                </SpecializationTag>
              ))}
            </SpecializationTags>
          </SpecializationContainer>
        </Section>

        {/* Education & Credentials Section */}
        <Section>
          <SectionTitle>Education & Credentials</SectionTitle>
          <EducationContainer>
            <EducationInputWrapper>
              <EducationInput
                placeholder="Add degree or certification"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleAddItem("education", e.target.value);
                    e.target.value = "";
                  }
                }}
              />
              <PlusButton
                onClick={() => {
                  const input = document.querySelector(".education-input");
                  if (input && input.value.trim()) {
                    handleAddItem("education", input.value);
                    input.value = "";
                  }
                }}
              >
                <FaPlus size={14} />
              </PlusButton>
            </EducationInputWrapper>
            <EducationList>
              {formData.education.map((edu, index) => (
                <EducationItem key={index}>
                  {edu}
                  <RemoveIcon
                    onClick={() => handleRemoveItem("education", index)}
                  />
                </EducationItem>
              ))}
            </EducationList>
          </EducationContainer>
        </Section>

        {/* Areas of Expertise Section */}
        <Section>
          <SectionTitle>Areas of Expertise</SectionTitle>
          <ExpertiseContainer>
            <ExpertiseInputWrapper>
              <ExpertiseInput
                placeholder="Add expertise area (e.g., Cognitive Behavioral Therapy)"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleAddItem("expertise", e.target.value);
                    e.target.value = "";
                  }
                }}
              />
              <PlusButton
                onClick={() => {
                  const input = document.querySelector(".expertise-input");
                  if (input && input.value.trim()) {
                    handleAddItem("expertise", input.value);
                    input.value = "";
                  }
                }}
              >
                <FaPlus size={14} />
              </PlusButton>
            </ExpertiseInputWrapper>
            <ExpertiseTags>
              {formData.expertise.map((exp, index) => (
                <ExpertiseTag key={index}>
                  {exp}{" "}
                  <RemoveIcon
                    onClick={() => handleRemoveItem("expertise", index)}
                    color="#1976d2"
                  />
                </ExpertiseTag>
              ))}
            </ExpertiseTags>
          </ExpertiseContainer>
        </Section>

        {/* Profile Tags Section */}
        <Section>
          <SectionTitle>Profile Tags</SectionTitle>
          <HelperText>
            Add searchable keywords to help students find you
          </HelperText>
          <TagContainer>
            <TagInputWrapper>
              <TagInput
                placeholder="Add tag (e.g., student counseling, exam stress)"
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleAddItem("tags", `#${e.target.value.trim()}`);
                    e.target.value = "";
                  }
                }}
              />
              <PlusButton
                onClick={() => {
                  const input = document.querySelector(".tag-input");
                  if (input && input.value.trim()) {
                    handleAddItem("tags", `#${input.value.trim()}`);
                    input.value = "";
                  }
                }}
              >
                <FaPlus size={14} />
              </PlusButton>
            </TagInputWrapper>
            <TagList>
              {formData.tags.map((tag, index) => (
                <Tag key={index}>
                  {tag}{" "}
                  <RemoveIcon onClick={() => handleRemoveItem("tags", index)} color="#9c27b0" />
                    
                </Tag>
              ))}
            </TagList>
          </TagContainer>
        </Section>

        {/* Professional Licenses & Certifications Section */}
        <Section>
          <SectionTitle>
            {/* <LicenseIcon>
              </LicenseIcon>  */}
              <IoShieldOutline color="#dc3545" />
              Professional Licenses & Certifications
          </SectionTitle>
          <HelperText>
            Add your professional licenses and certifications with verification
            details
          </HelperText>

          {formData.licenses.map((license, index) => (
            <LicenseCard key={license.id}>
              <CardHeader>
                <CardTitle>License #{index + 1}</CardTitle>
                <RemoveIcon onClick={() => handleRemoveLicense(license.id)} />
                 
              </CardHeader>

              <FormField>
                <Label>License/Certification Name</Label>
                <Input
                  value={license.name}
                  onChange={(e) =>
                    handleLicenseChange(license.id, "name", e.target.value)
                  }
                  placeholder="Enter license/certification name"
                />
              </FormField>

              <FormField>
                <Label>License Number</Label>
                <Input
                  value={license.number}
                  onChange={(e) =>
                    handleLicenseChange(license.id, "number", e.target.value)
                  }
                  placeholder="Enter license number"
                />
              </FormField>

              <DateRow>
                <DateField>
                  <Label>Issue Date</Label>
                  <Input
                    value={license.issueDate}
                    onChange={(e) =>
                      handleLicenseChange(
                        license.id,
                        "issueDate",
                        e.target.value
                      )
                    }
                    placeholder="Enter issue date"
                  />
                </DateField>
                <DateField>
                  <Label>Expiry Date</Label>
                  <Input
                    value={license.expiryDate}
                    onChange={(e) =>
                      handleLicenseChange(
                        license.id,
                        "expiryDate",
                        e.target.value
                      )
                    }
                    placeholder="Enter expiry date"
                  />
                </DateField>
              </DateRow>
            </LicenseCard>
          ))}

          <AddButton onClick={handleAddLicense}>
            {" "}
            <FaPlus size={14} style={{ marginRight: "0.5rem" }} /> Add
            License/Certification
          </AddButton>
        </Section>

        {/* Awards & Recognition Section */}
        <Section>
          <SectionTitle>
            <FiAward color="#F0B100" /> 
            Awards & Recognition
          </SectionTitle>
          <HelperText>
            Showcase your professional awards and industry recognition
          </HelperText>

          {formData.awards.map((award, index) => (
            <AwardCard key={award.id}>
              <CardHeader>
                <CardTitle>Award #{index + 1}</CardTitle>
                <RemoveIcon onClick={() => handleRemoveAward(award.id)} />
                 
              </CardHeader>

              <FormField>
                <Label>Award Title</Label>
                <Input
                  value={award.title}
                  onChange={(e) =>
                    handleAwardChange(award.id, "title", e.target.value)
                  }
                  placeholder="Enter award title"
                />
              </FormField>

              <TwoColumnGrid>
                <FormField>
                  <Label>Organization</Label>
                  <Input
                    value={award.organization}
                    onChange={(e) =>
                      handleAwardChange(
                        award.id,
                        "organization",
                        e.target.value
                      )
                    }
                    placeholder="Enter organization"
                  />
                </FormField>
                <FormField>
                  <Label>Year</Label>
                  <Input
                    value={award.year}
                    onChange={(e) =>
                      handleAwardChange(award.id, "year", e.target.value)
                    }
                    placeholder="Enter year"
                  />
                </FormField>
              </TwoColumnGrid>

              <FormField>
                <Label>Description</Label>
                <TextArea
                  value={award.description}
                  onChange={(e) =>
                    handleAwardChange(award.id, "description", e.target.value)
                  }
                  placeholder="Brief description of the award and why you received it"
                  rows="3"
                />
              </FormField>
            </AwardCard>
          ))}

          <AddButton onClick={handleAddAward}>
            {" "}
            <FaPlus size={14} style={{ marginRight: "0.5rem" }} /> Add Award
          </AddButton>
        </Section>

        {/* Achievements & Milestones Section */}
        <Section>
          <SectionTitle>
            <TfiStatsUp color="#00C950" />
            Achievements & Milestones
          </SectionTitle>
          <HelperText>
            Highlight notable achievements, publications, and professional
            milestones
          </HelperText>

          {formData.achievements.map((achievement, index) => (
            <AchievementCard key={achievement.id}>
              <CardHeader>
                <CardTitle>Achievement #{index + 1}</CardTitle>
                <RemoveIcon
                  onClick={() => handleRemoveAchievement(achievement.id)}
                />
              </CardHeader>

              <FormField>
                <Label>Achievement Title</Label>
                <Input
                  value={achievement.title}
                  onChange={(e) =>
                    handleAchievementChange(
                      achievement.id,
                      "title",
                      e.target.value
                    )
                  }
                  placeholder="Enter achievement title"
                />
              </FormField>

              <FormField>
                <Label>Year</Label>
                <Input
                  value={achievement.year}
                  onChange={(e) =>
                    handleAchievementChange(
                      achievement.id,
                      "year",
                      e.target.value
                    )
                  }
                  placeholder="Enter year"
                />
              </FormField>

              <FormField>
                <Label>Description</Label>
                <TextArea
                  value={achievement.description}
                  onChange={(e) =>
                    handleAchievementChange(
                      achievement.id,
                      "description",
                      e.target.value
                    )
                  }
                  placeholder="Detailed description of your achievement"
                  rows="3"
                />
              </FormField>
            </AchievementCard>
          ))}

          <AddButton onClick={handleAddAchievement}>
            {" "}
            <FaPlus size={14} style={{ marginRight: "0.5rem" }} /> Add
            Achievement
          </AddButton>
        </Section>

        {/* Professional Memberships Section */}
        <Section>
          <SectionTitle>
            <LuUsers color="#2B7FFF" />
            Professional Memberships
          </SectionTitle>
          <HelperText>
            List your memberships in professional associations and organizations
          </HelperText>

          {formData.memberships.map((membership, index) => (
            <MembershipCard key={membership.id}>
              <CardHeader>
                <CardTitle>Membership #{index + 1}</CardTitle>
                <RemoveIcon
                  onClick={() => handleRemoveMembership(membership.id)}
                />
              </CardHeader>

              <FormField>
                <Label>Organization Name</Label>
                <Input
                  value={membership.organization}
                  onChange={(e) =>
                    handleMembershipChange(
                      membership.id,
                      "organization",
                      e.target.value
                    )
                  }
                  placeholder="Enter organization name"
                />
              </FormField>

              <FormField>
                <Label>Role/Position</Label>
                <Input
                  value={membership.role}
                  onChange={(e) =>
                    handleMembershipChange(
                      membership.id,
                      "role",
                      e.target.value
                    )
                  }
                  placeholder="Enter your role/position"
                />
              </FormField>

              <FormField>
                <Label>Member Since</Label>
                <Input
                  value={membership.since}
                  onChange={(e) =>
                    handleMembershipChange(
                      membership.id,
                      "since",
                      e.target.value
                    )
                  }
                  placeholder="Enter year you became a member"
                />
              </FormField>
            </MembershipCard>
          ))}

          <AddButton onClick={handleAddMembership}>
            {" "}
            <FaPlus size={14} style={{ marginRight: "0.5rem" }} /> Add
            Membership
          </AddButton>
        </Section>

        {/* Verification Documents Section */}
        <Section>
          <SectionTitle>
            <IoDocumentTextOutline color="#FB2C36" />
            Verification Documents
          </SectionTitle>
          <HelperText>
            Upload verification documents (certificates, licenses, credentials)
          </HelperText>

          <DocumentList>
            {formData.documents.map((doc) => (
              <DocumentItem key={doc.id}>
                <DocumentIconSmall>
                   <IoDocumentTextOutline color="#FB2C36" />
                </DocumentIconSmall>
                <DocumentInfo>
                  <DocumentName>{doc.name}</DocumentName>
                  <DocumentType>{doc.type}</DocumentType>
                </DocumentInfo>
                <RemoveIcon onClick={() => handleRemoveDocument(doc.id)} />
              </DocumentItem>
            ))}
          </DocumentList>

          <UploadDocumentContainer>
            <UploadIconLarge>
              <LuUpload  size={24} />
            </UploadIconLarge>
            <UploadText>Upload Document</UploadText>
            <UploadSubtext>PDF, JPG, PNG up to 10MB</UploadSubtext>
            <FileInput type="file" onChange={handleFileUpload} />
          </UploadDocumentContainer>
        </Section>
      </FormWrapper>
    </Container>
  );
};

// Styled Components
const Container = styled.div`
  max-width: 80%;
  margin: 0 auto;
  padding: 20px;
  /* background-color: #f8f9fa; */
  margin-top: 100px;
  font-family: Montserrat;
`;

const Header = styled.div`
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #dee2e6;
`;

const BackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  display: flex;
  align-items: center;
  gap: 5px;

  &:hover {
    color: #0a0a0a;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const Section = styled.div`
  background: white;
  padding: 1.5rem;
  box-sizing: border-box;
  border: 1px solid rgba(229, 231, 235, 1);
  border-radius: 14px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1),
    0px 1px 2px -1px rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 1);
`;

const SectionTitle = styled.h2`
  font-size: 1rem;
  font-weight: 400;
  margin-bottom: 15px;
  color: #343a40;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

const AvatarPlaceholder = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const UploadButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-direction: column;
`;

const UploadButton = styled.button`
  background-color: #fb2c36;
  color: white;
  border: none;
  border-radius: 0.625rem;
  padding: 8px 16px;
  font-size: 1rem;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  width: fit-content;

  &:hover {
    background-color: #c82333;
  }
`;

const Recommendation = styled.p`
  font-size: 0.875rem;
  color: #6c757d;
  margin-top: 5px;
  font-weight: 400;
`;

const FormField = styled.div`
  margin-bottom: 15px;
  padding-right: 1.5rem;
`;

const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 400;
  margin-bottom: 5px;
  color: #0a0a0a;
`;

const Input = styled.input`
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 14px;
  transition: border-color 0.2s;

  box-sizing: border-box;
  border: 1px solid rgba(209, 213, 220, 1);
  border-radius: 10px;
  color: rgba(10, 10, 10, 0.5);

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
  resize: vertical;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const CharacterCount = styled.div`
  font-size: 12px;
  color: #6c757d;
  text-align: right;
  margin-top: 5px;
`;

const HelperText = styled.p`
  font-size: 13px;
  color: #6c757d;
  margin-bottom: 15px;
`;

const LanguageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const LanguageInputWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const LanguageInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const PlusButton = styled.button`
  border-radius: 10px;
  background: rgba(251, 44, 54, 1);
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  font-size: 0.75rem;
  font-weight: 400;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  min-height: 2.5rem;

  &:hover {
    background-color: #c82333;
  }
`;

const AddButton = styled.button`
  border-radius: 10px;
  background: #fb2c36;
  color: #fff;
  box-sizing: border-box;
  /* border: 1px solid #FB2C36; */
  border-radius: 10px;
  border: none;
  cursor: pointer;
  width: 20%;
  text-align: center;
  padding: 0.75rem;
  display: flex;
  font-size: 14px;
  font-weight: 400;
  align-items: center;
  justify-content: center;
  min-width: 2.5rem;
  min-height: 2.5rem;

  &:hover {
    background-color: #c82333;
    color: #fff;
  }
`;

const LanguageTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

const LanguageTag = styled.div`
  background-color: #e9ecef;
  padding: 5px 10px;
  border-radius: 20px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const RemoveIcon = styled(IoMdClose)`
  cursor: pointer;
  font-size: 14px;
  color: ${({ color }) => color || "#6c757d"};

  &:hover {
    color: #dc3545;
  }
`;

const SpecializationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const SpecializationInputWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const SpecializationInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const SpecializationTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

const SpecializationTag = styled.div`
  background-color: #fff0f0;
  border: none;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #dc3545;
`;

const EducationContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const EducationInputWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const EducationInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const EducationList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 10px;
`;

const EducationItem = styled.div`
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ExpertiseContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ExpertiseInputWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const ExpertiseInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const ExpertiseTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

const ExpertiseTag = styled.div`
  background-color: #e3f2fd;
  /* border: 1px solid #90caf9; */
  border: none;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #1976d2;
`;

const TagContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const TagInputWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

const TagInput = styled.input`
  flex: 1;
  padding: 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }
`;

const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
`;

const Tag = styled.div`
  background-color: #f3e5f5;
  border: none;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #9c27b0;
`;

const LicenseCard = styled.div`
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

const CardTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #0a0a0a;
`;

const DateRow = styled.div`
  display: flex;
  gap: 15px;
`;

const DateField = styled.div`
  flex: 1;
`;

const AwardCard = styled.div`
  background-color: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
`;

const AchievementCard = styled.div`
  background-color: #f1faee;
  border: 1px solid #a8e6cf;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
`;

const MembershipCard = styled.div`
  background-color: #e3f2fd;
  border: 1px solid #90caf9;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
`;

const TwoColumnGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
`;

const DocumentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 15px;
`;

const DocumentItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background-color: #f8f9fa;
`;

const DocumentIconSmall = styled.div`
  font-size: 20px;
  margin-right: 10px;
  padding: 10px;
  background-color: #FFE2E2;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const DocumentInfo = styled.div`
  flex: 1;
`;

const DocumentName = styled.div`
  font-weight: 500;
  margin-bottom: 3px;
`;

const DocumentType = styled.div`
  font-size: 12px;
  color: #6c757d;
`;

const UploadDocumentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  background-color: #f8f9fa;
  cursor: pointer;
  position: relative;

  &:hover {
    border-color: #007bff;
    background-color: #e9ecef;
  }
`;

const UploadIconLarge = styled.div`
  font-size: 24px;
  margin-bottom: 10px;
  color: #6c757d;
`;

const UploadText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #0a0a0a;
  margin-bottom: 5px;
`;

const UploadSubtext = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #6c757d;
`;

const FileInput = styled.input`
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  top: 0;
  left: 0;
`;

// Icons
const LicenseIcon = styled.span`
  font-size: 16px;
  color: #dc3545;
`;

const AwardIcon = styled.span`
  font-size: 16px;
  color: #ffc107;
`;

const AchievementIcon = styled.span`
  font-size: 16px;
  color: #28a745;
`;

const MembershipIcon = styled.span`
  font-size: 16px;
  color: #17a2b8;
`;

const DocumentIcon = styled.span`
  font-size: 16px;
  color: #6c757d;
`;

export default CreatorProfileForm;
